import { Module } from 'vuex'
import { InputValidationRule } from 'vuetify'

export type RuleBuilder = (...args: any[]) => InputValidationRule
export type Rule = InputValidationRule | RuleBuilder

export interface RulesDict {
  [key: string]: Rule
}

export interface ValidationModuleState {
  rules: RulesDict
}

const MIN_PASSWORD_LENGTH = 8

const validationModule: Module<ValidationModuleState, any> = {
  namespaced: true,
  state: {
    rules: {
      nonEmpty: (v: any) => !!v || 'Campo requerido',
      password: (v: string) =>
        !v ||
        v.length >= MIN_PASSWORD_LENGTH ||
        `La contraseña debe tener al menos ${MIN_PASSWORD_LENGTH} carácteres`,
      maxLength: (length: number) => (v: string) =>
        !v ||
        v.length <= length ||
        `El campo debe tener una longitud máxima de ${length}`,
      email: (v: string) =>
        /^\S+?@(?:[^\s.]+\.)+[^\s.]{2,}$/.test(v) || 'E-mail no válido',
      httpURL: (v: string) => {
        try {
          const url = new URL(v)
          if (!/^(?:http|https):$/.test(url.protocol)) {
            throw new Error('Invalid URL protocol')
          }
        } catch (err) {
          return 'URL no válida'
        }

        return true
      },
    },
  },
  mutations: {
    registerRule(state, { name, rule }: { name: string; rule: Rule }) {
      state.rules[name] = rule
    },
    unregisterRule(state, name: string) {
      delete state.rules[name]
    },
  },
}

export default validationModule
